import { useParamsSearch } from '@anytag/shared-hooks';
import { AutoManagedCommissionsSearchSchemaType } from '../schemaTypes';

export const useAutoManagedCommissionsFilter = () => useParamsSearch<AutoManagedCommissionsSearchSchemaType>();
